var _defs, _g, _rect, _rect2, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _rect3, _rect4, _rect5, _g7, _path4, _rect6, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeavrOnboardingPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 477.026,
    height: 391.29,
    viewBox: "0 0 477.026 391.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10778",
    "data-name": "Path 10778",
    d: "M7393.065,859.009c.02.7.055,1.39.1,2.073a46.211,46.211,0,0,0,1.069,7.2c.063.281.134.559.205.834.057.227.115.451.173.671.016.054.028.109.042.16.1.364.207.728.316,1.086.053.182.111.364.165.54.108.361.228.712.353,1.067.06.172.123.348.187.524s.122.332.18.5l.087.22c.037.1.075.208.118.31.067.176.136.355.211.527.138.345.275.684.426,1.022.071.166.145.336.223.5l.229.511c.077.163.154.326.234.485s.159.329.239.5c.016.035.034.07.053.105.037.074.074.144.11.214s.073.147.11.217c.074.144.147.288.225.435q.042.077.079.153c.062.109.12.217.177.326.146.268.293.531.444.8s.3.524.459.786q.466.776.959,1.533c.165.253.334.5.508.754s.342.5.516.741.354.489.533.732v0c.354.483.725.958,1.1,1.425v0c.192.236.383.469.576.7s.389.46.583.69.4.454.6.681c.163.182.33.364.5.543.1.1.188.2.284.3.239.255.484.511.736.764v0c.212.217.43.434.65.652s.439.428.664.639.446.425.674.633c.137.128.277.253.417.38.235.211.474.422.714.629q.5.431,1.008.853a62.7,62.7,0,0,0,7.611,5.4h0a77.928,77.928,0,0,0,12.332,6.009s0,0,0,0c.666.262,1.337.511,2.007.751.137.051.278.1.416.15h.007a96.508,96.508,0,0,0,12.86,3.562c.5.106,1.008.2,1.508.3,0,0,0,0,0,0s.008,0,.008,0c.193.041.375.077.564.112s.382.07.568.1a108.815,108.815,0,0,0,15.634,1.61c3.332.112,6.658.08,9.978-.07q.431-.014.856-.038c.72-.035,1.434-.077,2.149-.125,4.555-.3,9.1-.8,13.634-1.46q1.69-.244,3.382-.521c4.411-.709,8.814-1.556,13.207-2.479q1.318-.273,2.629-.562c.464-.1.932-.2,1.395-.3l2.061-.46c3.639-.818,7.267-1.674,10.891-2.54,1.077-.259,2.149-.515,3.224-.773,6.553-1.575,13.08-3.15,19.571-4.546h0q2.435-.527,4.858-1.013,2.578-.522,5.153-.984,1.339-.244,2.672-.47,1.57-.268,3.143-.5c.757-.112,1.515-.22,2.271-.32q.951-.124,1.9-.24,5.518-.666,11.067-.949c.1,0,.194-.01.293-.013s.225-.013.337-.016c.559-.029,1.121-.051,1.687-.073.013,0,.022,0,.034,0,.464-.016.924-.032,1.384-.042a.017.017,0,0,1,.011,0c.255-.01.515-.016.77-.022.438-.013.879-.022,1.317-.029.514-.01,1.023-.016,1.534-.022.416-.006.832-.006,1.248-.006h.38c.326,0,.658,0,.984.006.145,0,.289,0,.43,0h.186c.291,0,.579.006.871.013.192,0,.395,0,.6.006.229,0,.457.006.688.016.051,0,.095,0,.144,0,.175,0,.354.006.529.013.049,0,.1,0,.15,0s.129,0,.191,0c.169,0,.34.006.512.016.352.01.7.019,1.046.035l.5.019c.433.013.863.032,1.3.054.117,0,.237.006.357.016.157.006.31.013.464.022.279.013.554.026.829.045.14.006.275.016.406.022l.177.01c.032,0,.06,0,.094.006s.069,0,.1.006c.967.054,1.939.118,2.9.192.079.006.162.01.241.016.049,0,.093.01.142.013.024,0,.052,0,.076,0,.087.006.174.013.257.022.025,0,.053,0,.079.006l.481.038c.078.006.154.013.228.016.094.01.18.016.272.023.112.01.227.019.339.032.086.007.169.016.248.022s.176.016.263.022c.127.01.252.019.38.032.057.006.114.009.169.016.157.016.313.029.47.045l.112.01c.038,0,.078.006.115.013.185.016.37.032.557.051.235.022.469.045.7.07.167.016.333.035.5.051.3.029.592.061.889.1l.471.048c.172.016.342.035.515.054l.746.086a.287.287,0,0,1,.032.006c.741.086,1.475.176,2.213.272l.663.086.941.125.419.057c.287.038.573.08.856.121.3.042.6.086.9.131.331.048.662.1.991.147.644.1,1.286.2,1.933.3.42.067.845.137,1.27.211q2.919.489,5.832,1.064c.479.1.966.192,1.444.291.523.105,1.048.211,1.571.323,1.278.271,2.556.543,3.834.824.035.006.069.013.107.022l.148.032a.747.747,0,0,1,.076.016c.648.144,1.3.281,1.951.428q2.137.47,4.271.955h.008q2.073.465,4.144.943c2.743.633,5.475,1.268,8.215,1.91a.345.345,0,0,0,.06.016c.693.163,1.387.323,2.078.489l.524.125,1.3.307c.763.179,1.53.361,2.294.543,0,0,0,0,.006,0q2.585.608,5.175,1.22l.866.2c.086.019.17.041.255.061l1.953.46c.063.016.123.026.185.042l.01,0,.217.048q1.453.345,2.909.681c.267.064.535.125.8.188.044.01.09.019.139.032s.128.029.191.045c.115.026.233.054.354.083l.205.048a.116.116,0,0,1,.032.006c.185.042.369.086.558.128.17.042.343.08.515.118.022.007.044.01.063.016l.337.077c.159.038.318.077.479.112.414.1.826.189,1.246.281.681.16,1.367.316,2.054.473l.272.061c.647.144,1.295.291,1.948.438.633.144,1.265.281,1.895.422q.863.2,1.726.383c.435.093.865.188,1.3.281.555.124,1.111.243,1.668.364.153.032.31.067.459.1.052.013.105.026.155.035q.85.182,1.7.361c.216.048.434.093.647.137.448.093.892.189,1.336.278l1.289.268c.542.115,1.077.22,1.617.329.008,0,.018,0,.022,0q1.147.235,2.3.46l.172.035c5.877,1.156,11.76,2.208,17.64,3.086.531.083,1.059.16,1.585.236,4.79.693,9.581,1.278,14.384,1.719a212.719,212.719,0,0,0,24.137.917c1.7-.038,3.4-.1,5.1-.182q1.655-.082,3.308-.2,2.483-.168,4.973-.415,4.942-.474,9.9-1.265,4.424-.7,8.866-1.674,4.1-.891,8.22-2.029v0q2.624-.719,5.253-1.549,1.627-.508,3.265-1.064c.431-.144.866-.294,1.3-.447.222-.073.444-.15.666-.23a100.655,100.655,0,0,0,11.027-4.649.272.272,0,0,0,.066-.032c.386-.185.764-.377,1.146-.572h0l.018-.01c.036-.016.071-.032.107-.051.437-.224.876-.45,1.309-.68a104.879,104.879,0,0,0,9.212-5.483v0c.409-.272.817-.549,1.222-.828q3.448-2.368,6.7-5c.229-.185.457-.374.682-.562a104.9,104.9,0,0,0,11.74-11.287q1.792-2,3.469-4.1.441-.546.873-1.1c.287-.368.575-.738.854-1.112.208-.271.412-.543.613-.818.129-.166.254-.339.377-.508.032-.045.064-.086.1-.131.077-.109.157-.214.234-.323l.113-.16c.144-.2.285-.4.425-.594.029-.038.057-.077.084-.115.056-.073.105-.15.159-.227.128-.179.253-.355.377-.534.157-.23.317-.457.474-.687q1.748-2.554,3.338-5.217c.193-.323.383-.646.573-.971.261-.454.522-.911.775-1.371q.907-1.62,1.745-3.281c.146-.294.294-.588.437-.885.124-.249.247-.5.364-.751,0,0,0,0,0,0,.049-.1.094-.192.139-.287.172-.368.346-.741.517-1.112.129-.278.253-.559.378-.837q.368-.829.721-1.658c0-.01.01-.022.014-.032q.176-.426.354-.853c.233-.565.46-1.137.685-1.709.11-.288.22-.572.327-.86s.216-.578.319-.866c.145-.39.282-.773.421-1.16.28-.8.553-1.607.807-2.412,0,0,.008-.01,0-.016a93.591,93.591,0,0,0,3.371-14.224c.019-.112.039-.227.052-.345q.283-1.821.485-3.655a89.294,89.294,0,0,0,.548-11.434c-.008-.735-.032-1.467-.059-2.195-.008-.189-.017-.374-.027-.559-.034-.738-.079-1.476-.13-2.214q-.138-1.888-.361-3.757c0-.006,0-.016,0-.022a74.476,74.476,0,0,0-8.523-27.188,65.978,65.978,0,0,0-6.718-9.981,83.579,83.579,0,0,0-7.969-8.4c-2.277-2.112-4.654-4.134-7.078-6.1q-.426-.35-.864-.7c-6.124-4.923-12.532-9.575-18.5-14.674q-2.7-2.31-5.274-4.748c-.111-.109-.227-.214-.339-.323-3.544-3.364-6.94-6.875-10.3-10.415-4.451-4.687-8.841-9.422-13.425-13.923v0q-1.551-1.519-3.134-3a53.214,53.214,0,0,1-9.772-12.587v0a86.75,86.75,0,0,1-7.339-17.447c-.878-2.843-1.643-5.7-2.322-8.524-3.212-13.3-5.163-27.178-9.866-39.91a74.716,74.716,0,0,0-5.761-12.265c-12.5-21.083-38.144-33.546-62.44-30.351-13.189,1.732-25.136,7.46-36.417,14.68-8.74,5.594-17.086,12.086-25.3,18.31-14.1,10.671-29.541,21.552-46.5,27.351-2,.684-4.02,1.3-6.057,1.834a70.667,70.667,0,0,1-24.562,2.15,71.384,71.384,0,0,1-18.038-4.188c-11.366-4.156-21.992-10.719-32.58-17.508-2.181-1.4-4.357-2.808-6.539-4.2-4.074-2.607-8.16-5.185-12.3-7.6-.971-.569-1.951-1.115-2.93-1.648-12.511-6.741-25.671-10.211-37.755-7.652-9.023,1.907-17.446,7.172-24.547,16.949-11.131,15.306-13.646,35.261-13.114,54.184.3,10.808,3.227,21.53,6.705,32.121,2.726,8.287,5.793,16.492,8.217,24.591q.817,2.741,1.574,5.435.318,1.1.607,2.195.6,2.2,1.136,4.377a113.224,113.224,0,0,1,2.9,16.38s0,0,0,.007a66.541,66.541,0,0,1-.173,14.728v0a54.823,54.823,0,0,1-2.882,11.8,58.15,58.15,0,0,1-4.634,9.677c-.073.118-.143.236-.213.358q-1.126,1.859-2.43,3.725c-2.315,3.319-4.58,6.7-6.718,10.166-5.4,8.747-9.962,17.99-12.387,27.849l-.008.038c-.208.85-.4,1.7-.58,2.556-.056.287-.114.578-.169.866q-.195,1.04-.36,2.089c-.048.31-.1.62-.138.933-.093.617-.169,1.24-.239,1.863a.006.006,0,0,1,0,.01c-.032.313-.067.626-.1.942s-.058.629-.083.946c-.055.633-.094,1.265-.121,1.9s-.052,1.275-.063,1.917C7393.038,857.261,7393.039,858.134,7393.065,859.009Z",
    transform: "translate(-7844.679 -12890.772)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26989",
    "data-name": "Rectangle 26989",
    width: 389.906,
    height: 278.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26992",
    "data-name": "Rectangle 26992",
    width: 27.259,
    height: 6.686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26994",
    "data-name": "Rectangle 26994",
    width: 110.415,
    height: 3.37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26996",
    "data-name": "Rectangle 26996",
    width: 102.773,
    height: 5.103,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26998",
    "data-name": "Rectangle 26998",
    width: 51.289,
    height: 5.063,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27000",
    "data-name": "Rectangle 27000",
    width: 46.519,
    height: 5.06,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27004",
    "data-name": "Rectangle 27004",
    width: 194.874,
    height: 196.278,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67011",
    "data-name": "Path 67011",
    d: "M1029.595,202.723a29.018,29.018,0,0,0-17.734,26.754v24.77h8.536v-24.77a20.5,20.5,0,1,1,41,0v24.77h8.536v-24.77a29.052,29.052,0,0,0-40.343-26.754",
    transform: "translate(-1011.861 -200.439)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27099",
    "data-name": "Rectangle 27099",
    d: "M30.634,0H49.392A30.634,30.634,0,0,1,80.026,30.634v0A30.633,30.633,0,0,1,49.393,61.268H30.634A30.634,30.634,0,0,1,0,30.634v0A30.634,30.634,0,0,1,30.634,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67102",
    "data-name": "Path 67102",
    d: "M1159.877,580.123h-4.2v17.169h5.6V580.123Z",
    transform: "translate(-1155.676 -580.123)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27101",
    "data-name": "Rectangle 27101",
    width: 5.602,
    height: 17.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27135",
    "data-name": "Rectangle 27135",
    width: 456.075,
    height: 326.289,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66374",
    "data-name": "Group 66374",
    transform: "translate(-1013.602 -446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66361",
    "data-name": "Group 66361"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35313",
    "data-name": "Group 35313",
    transform: "translate(995 446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16177",
    "data-name": "Group 16177",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16065",
    "data-name": "Group 16065",
    transform: "translate(309.133 16.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10767",
    "data-name": "Path 10767",
    d: "M8585.41,747l-4.013.011-4.665.01c-15.918-21.491-.488-45.565-.488-45.565a41.743,41.743,0,0,1,10.86,19.908C8589.377,731.557,8587.394,741.009,8585.41,747Z",
    transform: "translate(-8567.987 -701.454)",
    fill: "#fff",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10768",
    "data-name": "Path 10768",
    d: "M8481.545,789.642l-10,.024c1.986-5.988,3.967-15.441,1.693-25.636a49.2,49.2,0,0,1,11.721-12.88C8491.32,767.215,8486.957,780.642,8481.545,789.642Z",
    transform: "translate(-8454.128 -744.123)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10769",
    "data-name": "Path 10769",
    d: "M8469.313,1023.153l-5.493,29.344-29.838.073-4.62-29.321,8.743-.022,4.669-.01,4.008-.012,10-.024Z",
    transform: "translate(-8429.362 -977.662)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16066",
    "data-name": "Group 16066",
    transform: "translate(210.011 71.162)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10770",
    "data-name": "Path 10770",
    d: "M8877.758,1091.831l-.043,19.807a1.249,1.249,0,0,0,1.244,1.252l73.129.157a1.254,1.254,0,0,0,1.254-1.247l.045-21.4a1.253,1.253,0,0,0-1.248-1.252l-64.447-.139Q8882.77,1090.577,8877.758,1091.831Z",
    transform: "translate(-8877.715 -1089.011)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10771",
    "data-name": "Path 10771",
    d: "M8388.432,2942.614a.527.527,0,0,0-.061,0c.021,0,.04,0,.063.006.059.006.12.01.176.013C8388.555,2942.627,8388.493,2942.621,8388.432,2942.614Z",
    transform: "translate(-8033.729 -2609.335)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10772",
    "data-name": "Path 10772",
    d: "M9454.943,2769.052s0,0-.006,0h0Z",
    transform: "translate(-9250.884 -2460.318)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10773",
    "data-name": "Path 10773",
    d: "M9455.533,2769.074h-.01s0,0,0,0h.006Z",
    transform: "translate(-9251.558 -2460.337)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10774",
    "data-name": "Path 10774",
    d: "M9455.592,2769.081c.05,0,.1,0,.148,0,0,0,0,0,0,0C9455.69,2769.078,9455.645,2769.078,9455.592,2769.081Z",
    transform: "translate(-9251.776 -2460.337)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10775",
    "data-name": "Path 10775",
    d: "M7951.784,1880.883c.009.115.021.227.031.342.723,8.275,4.815,16.093,9.739,22.885,13.414,18.514,33,31.424,52.146,43.919q2.657,1.731,5.312,3.464,5.253,3.426,10.518,6.84c.34.217.677.438,1.015.659,8.253,5.338,16.531,10.635,24.879,15.811.809.5,1.617,1,2.426,1.5h0a.016.016,0,0,0,.013.01q1.337-.245,2.67-.47,1.572-.268,3.143-.5c.759-.112,1.517-.221,2.272-.32q.951-.125,1.9-.24,5.517-.666,11.069-.949c.1,0,.193-.01.292-.013s.225-.013.336-.016c.56-.029,1.12-.051,1.688-.073.011,0,.021,0,.032,0,.464-.016.926-.032,1.384-.042a.017.017,0,0,1,.012,0c.256-.01.516-.016.769-.023q.659-.019,1.32-.029c.511-.01,1.023-.016,1.534-.022.414-.007.829-.007,1.246-.007h.38c.326,0,.658,0,.982.007.146,0,.291,0,.433,0h.185c.292,0,.578.007.87.013.194,0,.395,0,.6.006.229,0,.456.006.687.016.052,0,.1,0,.144,0,.176,0,.354.006.532.012.047,0,.1,0,.148,0s.128,0,.192,0c.169,0,.339.007.511.016.352.009.7.019,1.044.035l.5.019c.433.012.863.032,1.3.054.116,0,.236.006.358.015.156.006.309.013.462.022.279.013.556.026.831.045.14.007.276.016.407.022l.174.01a.882.882,0,0,1,.095.007c.036,0,.068,0,.1.006.968.054,1.939.118,2.9.192.08.006.163.009.242.016.05,0,.095.009.142.012.025,0,.052,0,.077,0,.086.006.173.012.256.022.024,0,.054,0,.08.006l.481.039c.075.007.154.013.228.016.092.009.179.016.271.022l.086.01c.084.006.17.012.253.022l.249.022c.086.006.176.016.264.022.127.01.251.019.379.032.058.007.116.01.17.017.156.016.313.028.468.044l.113.01c.037,0,.077.007.116.013.185.016.369.032.555.051.236.022.47.044.706.07l.5.051c.3.029.591.061.889.1l.469.048c.172.016.343.035.516.054l.748.086c.012,0,.021,0,.031.006.741.086,1.476.176,2.214.272l.661.086.943.125.418.058c.287.038.572.08.857.121s.6.086.9.131c.333.048.662.1.991.147.646.1,1.288.2,1.934.3.419.067.844.137,1.271.211q2.921.489,5.831,1.063c.479.1.965.192,1.444.291.522.105,1.047.211,1.571.323,1.277.271,2.556.543,3.833.824.036.006.07.013.109.022l.147.033a.549.549,0,0,1,.075.016c.65.144,1.3.281,1.953.428,1.424.313,2.845.629,4.271.955h.006q2.076.465,4.145.943c2.743.632,5.475,1.268,8.214,1.91a.335.335,0,0,0,.062.016c.692.163,1.387.323,2.077.489l.525.125,1.3.307c.763.178,1.53.361,2.293.543,0,0,0,0,.007,0q2.587.608,5.176,1.22l.864.2c.088.019.172.042.258.06l1.95.46c.064.016.126.026.187.042,0,0,0,0,.01,0,.07.02.143.035.218.051l.979.23.568.135c.033.006.064.012.1.022.424.1.842.192,1.26.291.269.064.536.124.8.188.046.01.092.019.139.032.063.013.128.029.19.045.116.026.235.054.355.083l.2.048a.1.1,0,0,1,.031.006c.185.041.371.086.56.128.171.042.343.08.514.118.023.006.046.01.066.016l.335.077c.158.039.318.076.479.112s.318.077.48.112q1.512.346,3.023.694l3.025.68q3.417.768,6.84,1.492c.617.134,1.233.265,1.848.4.332.067.662.137.993.2.672.144,1.351.284,2.029.422.357.073.714.147,1.071.217.777.157,1.551.313,2.324.463.054.01.11.022.161.032,5.88,1.159,11.762,2.207,17.646,3.089h0c.528.083,1.054.16,1.58.237,4.791.7,9.586,1.281,14.4,1.718h0a211.365,211.365,0,0,0,24.1.92q2.55-.053,5.1-.182h0c.007,0,.011-.009.019-.013.832-.543,1.648-1.128,2.446-1.748a48.731,48.731,0,0,0,5.938-5.489v0c.916-.99,1.8-2.022,2.664-3.083a77.245,77.245,0,0,0,10.2-17.019c1.7-3.786,3.2-7.681,4.57-11.6l0,0c.349-.99.69-1.987,1.022-2.981q.413-1.226.812-2.46c1.46-4.508,2.792-9.077,3.886-13.693a95.223,95.223,0,0,0,2.812-28.038c-.087-1.338-.222-2.77-.411-4.265,0,0,0-.009,0-.013-1.419-11.281-5.869-26.1-15.331-31.859a56.33,56.33,0,0,0-11.913-5.083c-5.149-1.677-10.543-3.134-15.527-5.22a46.881,46.881,0,0,1-4.818-2.316c-2.442-1.367-4.868-2.792-7.25-4.284-.088-.054-.178-.109-.264-.163-.571-.358-1.136-.722-1.7-1.089-3.386-2.189-6.677-4.518-9.816-7.013-.515-.409-1.023-.818-1.528-1.236-.868-.716-1.729-1.444-2.571-2.188q-3.215-.326-6.462-.617c-19.039-1.728-38.855-2.655-59.213-2.7q-2.587-.005-5.164.01c-.891,0-1.786.01-2.681.022C8068.936,1845.289,7999.045,1859.219,7951.784,1880.883Z",
    transform: "translate(-7875.482 -1666.54)",
    fill: "#1f60e5",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16067",
    "data-name": "Group 16067",
    transform: "translate(404.556 59.225)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10776",
    "data-name": "Path 10776",
    d: "M7901.447,1008.232a10.889,10.889,0,0,1,15.963-.305c2.221,2.347.438,7.347-1.084,9.789a10.382,10.382,0,0,1-10.636,4.767c-4.047-.883-7.25-5-6.715-9.1A10.079,10.079,0,0,1,7901.447,1008.232Z",
    transform: "translate(-7898.917 -1004.595)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16068",
    "data-name": "Group 16068",
    transform: "translate(455.035 129.282)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10777",
    "data-name": "Path 10777",
    d: "M7626.608,1501.45a4.3,4.3,0,0,1,6.3-.121c.876.926.172,2.9-.428,3.862a4.1,4.1,0,0,1-4.2,1.88,3.418,3.418,0,0,1-2.647-3.591A3.985,3.985,0,0,1,7626.608,1501.45Z",
    transform: "translate(-7625.611 -1500.016)",
    fill: "#1f60e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16081",
    "data-name": "Group 16081",
    transform: "translate(18.602 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16069",
    "data-name": "Group 16069",
    transform: "translate(0.002)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10778-2",
    "data-name": "Path 10778",
    d: "M7393.065,859.009c.02.7.055,1.39.1,2.073a46.211,46.211,0,0,0,1.069,7.2c.063.281.134.559.205.834.057.227.115.451.173.671.016.054.028.109.042.16.1.364.207.728.316,1.086.053.182.111.364.165.54.108.361.228.712.353,1.067.06.172.123.348.187.524s.122.332.18.5l.087.22c.037.1.075.208.118.31.067.176.136.355.211.527.138.345.275.684.426,1.022.071.166.145.336.223.5l.229.511c.077.163.154.326.234.485s.159.329.239.5c.016.035.034.07.053.105.037.074.074.144.11.214s.073.147.11.217c.074.144.147.288.225.435q.042.077.079.153c.062.109.12.217.177.326.146.268.293.531.444.8s.3.524.459.786q.466.776.959,1.533c.165.253.334.5.508.754s.342.5.516.741.354.489.533.732v0c.354.483.725.958,1.1,1.425v0c.192.236.383.469.576.7s.389.46.583.69.4.454.6.681c.163.182.33.364.5.543.1.1.188.2.284.3.239.255.484.511.736.764v0c.212.217.43.434.65.652s.439.428.664.639.446.425.674.633c.137.128.277.253.417.38.235.211.474.422.714.629q.5.431,1.008.853a62.7,62.7,0,0,0,7.611,5.4h0a77.928,77.928,0,0,0,12.332,6.009s0,0,0,0c.666.262,1.337.511,2.007.751.137.051.278.1.416.15h.007a96.508,96.508,0,0,0,12.86,3.562c.5.106,1.008.2,1.508.3,0,0,0,0,0,0s.008,0,.008,0c.193.041.375.077.564.112s.382.07.568.1a108.815,108.815,0,0,0,15.634,1.61c3.332.112,6.658.08,9.978-.07q.431-.014.856-.038c.72-.035,1.434-.077,2.149-.125,4.555-.3,9.1-.8,13.634-1.46q1.69-.244,3.382-.521c4.411-.709,8.814-1.556,13.207-2.479q1.318-.273,2.629-.562c.464-.1.932-.2,1.395-.3l2.061-.46c3.639-.818,7.267-1.674,10.891-2.54,1.077-.259,2.149-.515,3.224-.773,6.553-1.575,13.08-3.15,19.571-4.546h0q2.435-.527,4.858-1.013,2.578-.522,5.153-.984,1.339-.244,2.672-.47,1.57-.268,3.143-.5c.757-.112,1.515-.22,2.271-.32q.951-.124,1.9-.24,5.518-.666,11.067-.949c.1,0,.194-.01.293-.013s.225-.013.337-.016c.559-.029,1.121-.051,1.687-.073.013,0,.022,0,.034,0,.464-.016.924-.032,1.384-.042a.017.017,0,0,1,.011,0c.255-.01.515-.016.77-.022.438-.013.879-.022,1.317-.029.514-.01,1.023-.016,1.534-.022.416-.006.832-.006,1.248-.006h.38c.326,0,.658,0,.984.006.145,0,.289,0,.43,0h.186c.291,0,.579.006.871.013.192,0,.395,0,.6.006.229,0,.457.006.688.016.051,0,.095,0,.144,0,.175,0,.354.006.529.013.049,0,.1,0,.15,0s.129,0,.191,0c.169,0,.34.006.512.016.352.01.7.019,1.046.035l.5.019c.433.013.863.032,1.3.054.117,0,.237.006.357.016.157.006.31.013.464.022.279.013.554.026.829.045.14.006.275.016.406.022l.177.01c.032,0,.06,0,.094.006s.069,0,.1.006c.967.054,1.939.118,2.9.192.079.006.162.01.241.016.049,0,.093.01.142.013.024,0,.052,0,.076,0,.087.006.174.013.257.022.025,0,.053,0,.079.006l.481.038c.078.006.154.013.228.016.094.01.18.016.272.023.112.01.227.019.339.032.086.007.169.016.248.022s.176.016.263.022c.127.01.252.019.38.032.057.006.114.009.169.016.157.016.313.029.47.045l.112.01c.038,0,.078.006.115.013.185.016.37.032.557.051.235.022.469.045.7.07.167.016.333.035.5.051.3.029.592.061.889.1l.471.048c.172.016.342.035.515.054l.746.086a.287.287,0,0,1,.032.006c.741.086,1.475.176,2.213.272l.663.086.941.125.419.057c.287.038.573.08.856.121.3.042.6.086.9.131.331.048.662.1.991.147.644.1,1.286.2,1.933.3.42.067.845.137,1.27.211q2.919.489,5.832,1.064c.479.1.966.192,1.444.291.523.105,1.048.211,1.571.323,1.278.271,2.556.543,3.834.824.035.006.069.013.107.022l.148.032a.747.747,0,0,1,.076.016c.648.144,1.3.281,1.951.428q2.137.47,4.271.955h.008q2.073.465,4.144.943c2.743.633,5.475,1.268,8.215,1.91a.345.345,0,0,0,.06.016c.693.163,1.387.323,2.078.489l.524.125,1.3.307c.763.179,1.53.361,2.294.543,0,0,0,0,.006,0q2.585.608,5.175,1.22l.866.2c.086.019.17.041.255.061l1.953.46c.063.016.123.026.185.042l.01,0,.217.048q1.453.345,2.909.681c.267.064.535.125.8.188.044.01.09.019.139.032s.128.029.191.045c.115.026.233.054.354.083l.205.048a.116.116,0,0,1,.032.006c.185.042.369.086.558.128.17.042.343.08.515.118.022.007.044.01.063.016l.337.077c.159.038.318.077.479.112.414.1.826.189,1.246.281.681.16,1.367.316,2.054.473l.272.061c.647.144,1.295.291,1.948.438.633.144,1.265.281,1.895.422q.863.2,1.726.383c.435.093.865.188,1.3.281.555.124,1.111.243,1.668.364.153.032.31.067.459.1.052.013.105.026.155.035q.85.182,1.7.361c.216.048.434.093.647.137.448.093.892.189,1.336.278l1.289.268c.542.115,1.077.22,1.617.329.008,0,.018,0,.022,0q1.147.235,2.3.46l.172.035c5.877,1.156,11.76,2.208,17.64,3.086.531.083,1.059.16,1.585.236,4.79.693,9.581,1.278,14.384,1.719a212.719,212.719,0,0,0,24.137.917c1.7-.038,3.4-.1,5.1-.182q1.655-.082,3.308-.2,2.483-.168,4.973-.415,4.942-.474,9.9-1.265,4.424-.7,8.866-1.674,4.1-.891,8.22-2.029v0q2.624-.719,5.253-1.549,1.627-.508,3.265-1.064c.431-.144.866-.294,1.3-.447.222-.073.444-.15.666-.23a100.655,100.655,0,0,0,11.027-4.649.272.272,0,0,0,.066-.032c.386-.185.764-.377,1.146-.572h0l.018-.01c.036-.016.071-.032.107-.051.437-.224.876-.45,1.309-.68a104.879,104.879,0,0,0,9.212-5.483v0c.409-.272.817-.549,1.222-.828q3.448-2.368,6.7-5c.229-.185.457-.374.682-.562a104.9,104.9,0,0,0,11.74-11.287q1.792-2,3.469-4.1.441-.546.873-1.1c.287-.368.575-.738.854-1.112.208-.271.412-.543.613-.818.129-.166.254-.339.377-.508.032-.045.064-.086.1-.131.077-.109.157-.214.234-.323l.113-.16c.144-.2.285-.4.425-.594.029-.038.057-.077.084-.115.056-.073.105-.15.159-.227.128-.179.253-.355.377-.534.157-.23.317-.457.474-.687q1.748-2.554,3.338-5.217c.193-.323.383-.646.573-.971.261-.454.522-.911.775-1.371q.907-1.62,1.745-3.281c.146-.294.294-.588.437-.885.124-.249.247-.5.364-.751,0,0,0,0,0,0,.049-.1.094-.192.139-.287.172-.368.346-.741.517-1.112.129-.278.253-.559.378-.837q.368-.829.721-1.658c0-.01.01-.022.014-.032q.176-.426.354-.853c.233-.565.46-1.137.685-1.709.11-.288.22-.572.327-.86s.216-.578.319-.866c.145-.39.282-.773.421-1.16.28-.8.553-1.607.807-2.412,0,0,.008-.01,0-.016a93.591,93.591,0,0,0,3.371-14.224c.019-.112.039-.227.052-.345q.283-1.821.485-3.655a89.294,89.294,0,0,0,.548-11.434c-.008-.735-.032-1.467-.059-2.195-.008-.189-.017-.374-.027-.559-.034-.738-.079-1.476-.13-2.214q-.138-1.888-.361-3.757c0-.006,0-.016,0-.022a74.476,74.476,0,0,0-8.523-27.188,65.978,65.978,0,0,0-6.718-9.981,83.579,83.579,0,0,0-7.969-8.4c-2.277-2.112-4.654-4.134-7.078-6.1q-.426-.35-.864-.7c-6.124-4.923-12.532-9.575-18.5-14.674q-2.7-2.31-5.274-4.748c-.111-.109-.227-.214-.339-.323-3.544-3.364-6.94-6.875-10.3-10.415-4.451-4.687-8.841-9.422-13.425-13.923v0q-1.551-1.519-3.134-3a53.214,53.214,0,0,1-9.772-12.587v0a86.75,86.75,0,0,1-7.339-17.447c-.878-2.843-1.643-5.7-2.322-8.524-3.212-13.3-5.163-27.178-9.866-39.91a74.716,74.716,0,0,0-5.761-12.265c-12.5-21.083-38.144-33.546-62.44-30.351-13.189,1.732-25.136,7.46-36.417,14.68-8.74,5.594-17.086,12.086-25.3,18.31-14.1,10.671-29.541,21.552-46.5,27.351-2,.684-4.02,1.3-6.057,1.834a70.667,70.667,0,0,1-24.562,2.15,71.384,71.384,0,0,1-18.038-4.188c-11.366-4.156-21.992-10.719-32.58-17.508-2.181-1.4-4.357-2.808-6.539-4.2-4.074-2.607-8.16-5.185-12.3-7.6-.971-.569-1.951-1.115-2.93-1.648-12.511-6.741-25.671-10.211-37.755-7.652-9.023,1.907-17.446,7.172-24.547,16.949-11.131,15.306-13.646,35.261-13.114,54.184.3,10.808,3.227,21.53,6.705,32.121,2.726,8.287,5.793,16.492,8.217,24.591q.817,2.741,1.574,5.435.318,1.1.607,2.195.6,2.2,1.136,4.377a113.224,113.224,0,0,1,2.9,16.38s0,0,0,.007a66.541,66.541,0,0,1-.173,14.728v0a54.823,54.823,0,0,1-2.882,11.8,58.15,58.15,0,0,1-4.634,9.677c-.073.118-.143.236-.213.358q-1.126,1.859-2.43,3.725c-2.315,3.319-4.58,6.7-6.718,10.166-5.4,8.747-9.962,17.99-12.387,27.849l-.008.038c-.208.85-.4,1.7-.58,2.556-.056.287-.114.578-.169.866q-.195,1.04-.36,2.089c-.048.31-.1.62-.138.933-.093.617-.169,1.24-.239,1.863a.006.006,0,0,1,0,.01c-.032.313-.067.626-.1.942s-.058.629-.083.946c-.055.633-.094,1.265-.121,1.9s-.052,1.275-.063,1.917C7393.038,857.261,7393.039,858.134,7393.065,859.009Z",
    transform: "translate(-7393.043 -585.773)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10779",
    "data-name": "Path 10779",
    d: "M7393.064,1934.194c.019.706.055,1.406.105,2.1a46.225,46.225,0,0,0,1.069,7.2c.063.281.134.559.205.834.057.227.115.45.173.671.016.054.028.109.042.16.1.364.207.728.316,1.086.053.182.111.364.165.54.112.361.23.712.353,1.067.06.172.123.348.187.524s.122.332.18.5l.087.221c.037.1.075.208.118.31.067.176.136.354.211.527.138.345.275.683.426,1.022.071.166.145.336.223.5s.152.339.229.512.154.325.234.485.159.329.239.5c.016.035.034.07.053.105.037.074.074.144.11.214s.073.147.11.218c.074.144.147.288.225.435q.042.076.079.154c.062.109.12.217.177.326.146.268.293.53.444.8s.3.524.459.786q.466.776.959,1.533c.165.252.334.5.508.754s.342.5.516.741.354.49.533.732v0c.36.482.73.958,1.1,1.425v0c.192.237.383.469.576.7s.389.46.583.691.4.453.6.68c.163.182.33.364.5.543.1.1.19.2.287.3q.36.384.733.763v0c.212.217.43.435.65.652s.439.428.664.639.446.425.674.633c.137.127.277.252.417.38.235.211.474.422.714.63q.5.431,1.008.853a63.226,63.226,0,0,0,7.619,5.389h0a78.194,78.194,0,0,0,12.281,5.984h0q1.03.4,2.071.773c.139.055.276.1.417.151a0,0,0,0,0,0,0,97.784,97.784,0,0,0,12.875,3.56c.51.1,1.023.207,1.534.3,0,0,0,0,0,0,.169.035.341.067.509.1.2.038.411.076.616.108h0a107.879,107.879,0,0,0,15.606,1.607h0c3.32.112,6.638.08,9.954-.07.284-.01.568-.023.849-.038h0c5.272-.265,10.531-.821,15.776-1.585,5.547-.8,11.081-1.837,16.6-3,.873-.185,1.751-.371,2.625-.562q1.73-.375,3.454-.764c3.639-.818,7.271-1.677,10.9-2.543,7.631-1.821,15.225-3.687,22.777-5.31q2.435-.527,4.866-1.013,2.583-.517,5.155-.987h0l1.2-.214c.493-.086.985-.169,1.477-.252q1.576-.268,3.152-.5,2.1-.311,4.188-.562,5.818-.7,11.671-.974h0q1.559-.077,3.116-.118a0,0,0,0,1,.006,0h0c.256-.009.508-.016.765-.022.438-.012.874-.022,1.315-.029h0c.514-.009,1.023-.016,1.534-.019.416-.007.832-.007,1.248-.007h.38c.326,0,.658,0,.984.007.145,0,.289,0,.43,0h.186c.291,0,.579.006.871.012.192,0,.395,0,.6.006.229,0,.457.007.688.017.051,0,.095,0,.144,0,.175,0,.354.006.529.012.049,0,.1,0,.15,0s.129,0,.191,0c.169,0,.34.006.512.016.352.009.7.019,1.046.035l.5.019c.433.013.863.032,1.3.054.117,0,.237.007.357.016.157.007.31.013.464.023.279.013.554.026.829.045.14.006.275.016.406.022l.177.01c.032,0,.06,0,.094.006s.069,0,.1.007c.967.054,1.939.118,2.9.191.079.007.162.01.241.016s.148.01.218.016c.087.006.174.012.257.022.025,0,.053,0,.079.006.24.013.474.035.709.054.094.01.18.016.272.023.112.009.227.019.339.031l.248.022.263.023c.127.009.252.019.38.032l.169.015c.4.035.8.071,1.208.113.017,0,.029,0,.046.006.235.022.469.044.7.07.167.013.333.029.5.051a.631.631,0,0,1,.077.007c.1.013.2.022.3.032.5.052,1,.1,1.5.16l.746.087a.23.23,0,0,1,.032.006c.741.087,1.475.176,2.213.272l.663.086.941.125.419.057c.287.039.573.08.856.122.3.041.6.086.9.131.331.048.662.1.991.147.644.1,1.286.2,1.933.3.42.067.845.137,1.27.211q2.919.488,5.832,1.064c.479.1.966.191,1.444.291.523.105,1.048.21,1.571.323,1.278.271,2.556.543,3.834.824.035.007.069.013.107.022s.1.022.148.032a.687.687,0,0,1,.076.016c.648.144,1.3.281,1.951.428q2.137.469,4.271.955h.008q2.073.465,4.144.943c2.743.632,5.475,1.268,8.215,1.911a.409.409,0,0,0,.06.016c.693.163,1.387.323,2.078.489l.524.124,1.3.307c.763.179,1.53.361,2.294.543,0,0,0,0,.006,0q2.585.609,5.175,1.22l.866.2.255.061,1.953.46c.063.016.123.025.185.041,0,0,.007,0,.01,0,.07.019.145.035.217.052q.494.114.98.23l.569.134c.033.006.065.013.1.022.423.1.84.192,1.26.291.267.064.535.125.8.188.044.01.09.02.139.032s.128.029.191.045c.115.025.233.054.354.083l.205.048a.117.117,0,0,1,.032.007c.185.042.369.086.558.128.17.042.343.08.515.118.022.006.044.01.063.016l.337.077c.159.039.318.077.479.112s.319.077.481.112c1.008.23,2.013.463,3.022.693l3.026.68q3.416.767,6.84,1.492c.616.135,1.233.265,1.847.4.332.067.661.138.993.2q1.012.215,2.028.421c.359.074.717.147,1.073.218.777.156,1.55.313,2.325.463.054.01.107.023.161.032,5.88,1.16,11.761,2.208,17.646,3.089h0c.528.083,1.053.16,1.579.237,4.791.7,9.587,1.281,14.4,1.719h0a211.335,211.335,0,0,0,24.1.921q2.55-.053,5.1-.182h0c1.113-.055,2.221-.118,3.332-.2q2.484-.167,4.968-.412,4.937-.478,9.894-1.268,4.427-.7,8.878-1.674,4.1-.892,8.207-2.029,2.625-.718,5.258-1.55,1.63-.508,3.262-1.063c.433-.144.867-.294,1.3-.448.22-.073.444-.15.664-.23a101.233,101.233,0,0,0,11.032-4.645.521.521,0,0,0,.066-.032c.394-.191.781-.386,1.169-.584l.1-.048q.669-.341,1.335-.7h0a104.971,104.971,0,0,0,9.188-5.469c.408-.271.813-.55,1.22-.827q3.456-2.372,6.715-5.016c.23-.182.456-.368.685-.56a104.278,104.278,0,0,0,11.737-11.29c.271-.3.537-.6.8-.907q1.37-1.568,2.657-3.2.441-.546.873-1.1c.287-.367.575-.738.854-1.111.208-.272.412-.543.613-.818.129-.167.254-.339.377-.508.032-.045.064-.086.1-.131.077-.108.157-.214.234-.323l.113-.16c.144-.2.285-.4.425-.594.029-.038.057-.076.084-.115.056-.073.105-.15.159-.227.128-.179.253-.354.377-.534.163-.227.327-.453.483-.683q1.742-2.544,3.326-5.2c.2-.332.4-.664.588-1,.265-.45.524-.908.775-1.368q.905-1.62,1.732-3.278c.146-.294.294-.588.437-.885.124-.249.247-.5.364-.751,0,0,0,0,0,0,.049-.1.094-.192.139-.288.172-.367.346-.741.517-1.112.129-.278.253-.559.378-.837q.368-.829.721-1.658c0-.01.01-.022.014-.032q.176-.426.354-.853c.233-.565.46-1.137.685-1.709.11-.287.22-.572.327-.859s.216-.578.319-.866c.145-.39.282-.773.421-1.159.28-.8.553-1.607.807-2.412,0,0,.008-.01,0-.016a93.581,93.581,0,0,0,3.371-14.223c.019-.112.039-.227.052-.345q.283-1.822.485-3.655a89.3,89.3,0,0,0,.548-11.435c-.008-.734-.032-1.466-.059-2.195-.008-.188-.017-.374-.027-.559-.034-.738-.079-1.476-.13-2.214q-.138-1.889-.361-3.758a243.061,243.061,0,0,0-29.779-13.8q-12.68-4.935-27-9.178h0c-.025-.009-.053-.016-.077-.025s-.059-.016-.086-.025c-.424-.125-.85-.252-1.279-.377-.057-.016-.118-.032-.174-.051q-13.731-4-28.79-7.31-2.112-.464-4.256-.914a.1.1,0,0,0-.014,0q-3.032-.638-6.1-1.24-8.142-1.606-16.6-2.994-1.979-.325-3.975-.636c-.38-.061-.758-.121-1.138-.178-.072-.01-.149-.022-.223-.035l-.171-.025q-11.471-1.768-23.446-3.118a.036.036,0,0,1-.019,0c-.124-.013-.249-.028-.377-.041h0q-3.97-.445-7.993-.847-2.339-.23-4.7-.444c-19.476-1.782-39.779-2.725-60.647-2.725q-2.5,0-4.99.019c-.886,0-1.776.009-2.665.022-77.959.853-147.475,14.833-194.48,36.466-.036.016-.075.032-.109.048q-6.65,3.062-12.692,6.329-3.151,1.7-6.121,3.457c-16.9,9.968-29.464,21.149-36.649,33.134l-.008.016c-.208.856-.4,1.716-.58,2.578-.056.288-.114.578-.169.866q-.195,1.039-.36,2.089c-.048.31-.1.62-.138.933-.093.617-.169,1.24-.239,1.863,0,0,0,.007,0,.01-.032.313-.067.626-.1.942s-.058.63-.083.946c-.055.633-.094,1.265-.121,1.9s-.056,1.275-.063,1.917Q7393.028,1932.889,7393.064,1934.194Z",
    transform: "translate(-7393.043 -1660.98)",
    fill: "#e3e0ff",
    opacity: 0.872
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16077",
    "data-name": "Group 16077",
    transform: "translate(11.865 21.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16073",
    "data-name": "Group 16073",
    transform: "translate(0 16.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16070",
    "data-name": "Group 16070",
    transform: "translate(34.982 15.419)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10780",
    "data-name": "Path 10780",
    d: "M10138.563,969.825l-.268-8.2a.263.263,0,0,0-.271-.255l-47.826,1.552a.262.262,0,0,0-.253.272l.265,8.2a.264.264,0,0,0,.271.255l47.826-1.552A.266.266,0,0,0,10138.563,969.825Z",
    transform: "translate(-10089.747 -961.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17866",
    "data-name": "Rectangle 17866",
    width: 20.552,
    height: 41.467,
    rx: 2.958,
    transform: "translate(42.268 8.566) rotate(88.141)",
    fill: "#fff",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17867",
    "data-name": "Rectangle 17867",
    width: 17.642,
    height: 55.835,
    rx: 2.958,
    transform: "translate(55.805 27.597) rotate(88.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10781",
    "data-name": "Path 10781",
    d: "M10181.8,1060.936c.594-3.33-.15-7.2-.381-10.565a.484.484,0,0,0-.967.031c-.012,3.373-.5,7.283.309,10.568A.533.533,0,0,0,10181.8,1060.936Z",
    transform: "translate(-10145.984 -1037.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10782",
    "data-name": "Path 10782",
    d: "M10216.078,1062.049c.594-3.329-.152-7.2-.381-10.565a.483.483,0,0,0-.965.031c-.012,3.373-.5,7.283.3,10.568A.535.535,0,0,0,10216.078,1062.049Z",
    transform: "translate(-10185.11 -1038.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10783",
    "data-name": "Path 10783",
    d: "M10250.357,1063.161c.594-3.329-.152-7.2-.381-10.565a.483.483,0,0,0-.965.031c-.012,3.372-.506,7.283.3,10.567A.535.535,0,0,0,10250.357,1063.161Z",
    transform: "translate(-10224.236 -1039.309)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10784",
    "data-name": "Path 10784",
    d: "M8375.088,951.062l-1.045-32.223-24.434.792-.145-4.412,24.435-.793-1.731-53.4-.02-.623c.486-.585.966-1.179,1.434-1.776.095-.118.187-.236.279-.358q2.219-2.871,4.136-5.936l.1,3.185,60.309-1.958c2.186,1.4,4.361,2.805,6.543,4.2l-66.7,2.163,1.759,54.3,4.99-.163h.028l30.294-.984,25.454-.827h.027l61.336-1.99,19.043-.616-1.05-32.335c2.036-.533,4.057-1.15,6.059-1.834l1.1,33.971,18.634-.6,1.67-.054,21.125-.681,6.709-.214,10.376-.339,44.079-1.425,19.091-.616,3.981-.128,10.5-.339,4.942-.16h0l1.547-.048,9.3-.3.14,4.412-12.775.412-.593.019-4.362.141-10.229.329-.987.032-10.979.355h0l-5.337.172h0l-.67.022-.541.016h0l-2.549.083-52.553,1.7-5.959.192-40.289,1.3-.484.016-3.638.118.043,1.252,2.315,71.373-6.105.2-.5-15.271-50.457,1.636-74.631,2.422-16.078.524.222,58.619.1,25.255v.007l.114,30.322,0,.761.053,1.7-6.11.2-.035-1.121-.074-2.3-.1-30.443-.07-20.926-.212-61.877-9.906.319q-.539-2.176-1.135-4.377l10.9-.354-.459-14.246Zm18.1,20.15,2.528-.083,10.777-.348h0l2.878-.1h0l11.941-.383.1,0,7.03-.233h0l7.336-.233,29.907-.971,57.348-1.866-1.618-49.83-.1-3.106-109.2,3.543-31.974,1.035,1.717,52.945Z",
    transform: "translate(-8349.465 -852.335)",
    fill: "#fff",
    opacity: 0.244
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10785",
    "data-name": "Path 10785",
    d: "M10093.664,1449.952l-5.568,2.534a.327.327,0,0,1-.434-.163l-17.766-39.03a.332.332,0,0,1,.162-.435l5.57-2.533a.33.33,0,0,1,.436.163l17.76,39.031A.329.329,0,0,1,10093.664,1449.952Z",
    transform: "translate(-10007.216 -1331.394)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16071",
    "data-name": "Group 16071",
    transform: "translate(34.826 71.483)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    "data-name": "Path 10786",
    d: "M10299.83,1406.29l-12.234,2.44a.329.329,0,0,1-.387-.258l-9.533-47.794a.325.325,0,0,1,.256-.386l12.234-2.44a.327.327,0,0,1,.385.258l9.535,47.794A.328.328,0,0,1,10299.83,1406.29Z",
    transform: "translate(-10277.668 -1357.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    "data-name": "Path 10787",
    d: "M10362.924,1395.7c-2.211-.293-4.541.639-6.664,1.066-.506.1-.65.679-.545,1.208s.463,1.009.965.907c2.125-.42,4.635-.454,6.564-1.573A.973.973,0,0,0,10362.924,1395.7Z",
    transform: "translate(-10352.156 -1390.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M10337.562,1522.812c-2.211-.293-4.544.639-6.666,1.066-.5.1-.648.679-.542,1.208s.461,1.008.967.907c2.121-.42,4.634-.455,6.56-1.572A.973.973,0,0,0,10337.562,1522.812Z",
    transform: "translate(-10323.206 -1499.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M10360.367,1453.982a1.987,1.987,0,0,0-1.156,2.464c.234,1.17,1.15,2,2.012,1.831a1.99,1.99,0,0,0,1.156-2.464C10362.143,1454.643,10361.229,1453.81,10360.367,1453.982Z",
    transform: "translate(-10351.532 -1440.368)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16072",
    "data-name": "Group 16072",
    transform: "translate(50.192 78.942)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M10195.069,1450.062l-10.694,2.874a.331.331,0,0,1-.4-.231l-10.435-38.828a.331.331,0,0,1,.232-.4l10.7-2.875a.326.326,0,0,1,.4.232l10.436,38.828A.328.328,0,0,1,10195.069,1450.062Z",
    transform: "translate(-10173.525 -1410.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M10260.6,1458.216c-.768.206-1.058,1.683-.636,3.247s1.411,2.7,2.179,2.491,1.056-1.683.634-3.247S10261.369,1458.01,10260.6,1458.216Z",
    transform: "translate(-10253.385 -1451.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M10237.279,1537.9c-1.034.187-2.042.484-3.058.74a5.887,5.887,0,0,0-2.659.981c-.383.331-.012,1.716.488,1.811a5.894,5.894,0,0,0,2.792-.484c1.007-.287,2.027-.536,3.017-.892.36-.057.379-.66.219-1.215C10237.938,1538.277,10237.62,1537.765,10237.279,1537.9Z",
    transform: "translate(-10224.572 -1519.876)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16076",
    "data-name": "Group 16076",
    transform: "translate(33.435)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M10161.285,742.839A28.6,28.6,0,0,0,10201.56,744c-12.511-6.742-25.669-10.213-37.753-7.654q-.262.753-.526,1.5-.419,1.183-.881,2.346C10162.049,741.081,10161.674,741.962,10161.285,742.839Z",
    transform: "translate(-10161.285 -735.505)",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16074",
    "data-name": "Group 16074",
    transform: "translate(20.799 9.511)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17868",
    "data-name": "Rectangle 17868",
    width: 5.128,
    height: 1.243,
    transform: "matrix(-0.032, -0.999, 0.999, -0.032, 0.165, 5.165)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16075",
    "data-name": "Group 16075",
    transform: "translate(2.384 3.424)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M10398.041,763.46l.9.851,3.507-3.741-.907-.849Z",
    transform: "translate(-10398.041 -759.721)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16080",
    "data-name": "Group 16080",
    transform: "translate(8.974 51.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M10619.468,1844.1c-2.736,2.673-2.464,7.826.654,10.042s8.234.6,9.338-3.065-2.524-7.911-6.286-7.227a10.882,10.882,0,0,0-3.62,1.641Z",
    transform: "translate(-10617.586 -1716.891)",
    fill: "#dbd9f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16078",
    "data-name": "Group 16078",
    transform: "translate(39.191 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_820",
    "data-name": "Ellipse 820",
    cx: 4.385,
    cy: 4.385,
    rx: 4.385,
    ry: 4.385,
    transform: "translate(17.779 9.082) rotate(-92.077)",
    fill: "#fff",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M10411.426,1032.208a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,10411.426,1032.208Z",
    transform: "translate(-10410.33 -1020.082)",
    fill: "#fff",
    opacity: 0.79
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16079",
    "data-name": "Group 16079",
    transform: "translate(221.01 13.896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_821",
    "data-name": "Ellipse 821",
    cx: 3.351,
    cy: 3.351,
    r: 3.351,
    transform: "matrix(-0.675, -0.738, 0.738, -0.675, 4.522, 9.47)",
    fill: "#fff",
    opacity: 0.65
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16097",
    "data-name": "Group 16097",
    transform: "translate(150.941 28.781)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M9342.051,815.445c-13.187-.317-27-6.494-33.158-18.007-.8-1.5-1.475-3.275-.855-4.856a4.947,4.947,0,0,1,2.879-2.552c4.795-1.948,10.283.307,14.463,3.361s7.826,6.973,12.588,9c6.7,2.842,14.4,1.449,21.348-.7,7.145-2.21,15.42-8.127,22.406-2.713-.937,4.392-4.418,5.267-8.129,6.818-6.584,2.751-13.578,6.682-20.479,8.449A40.828,40.828,0,0,1,9342.051,815.445Z",
    transform: "translate(-9307.795 -789.304)",
    fill: "#f1f0fc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31",
    "data-name": "Mask Group 31",
    transform: "translate(1465.238 12751)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66355",
    "data-name": "Group 66355",
    transform: "translate(687.162 62.549)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27118",
    "data-name": "Rectangle 27118",
    width: 302.562,
    height: 210.644,
    transform: "translate(-1062.443 -12231.673)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27120",
    "data-name": "Rectangle 27120",
    width: 302.562,
    height: 25.225,
    transform: "translate(-1062.521 -12238.682)",
    fill: "#7181bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66343",
    "data-name": "Group 66343",
    transform: "translate(-1095.24 -12282.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66329",
    "data-name": "Group 66329",
    clipPath: "url(#clip-path-2)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66313",
    "data-name": "Group 66313",
    transform: "translate(39.132 52.625)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66312",
    "data-name": "Group 66312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66311",
    "data-name": "Group 66311",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67002",
    "data-name": "Path 67002",
    d: "M257.564,340.843a3.335,3.335,0,1,1-3.338-3.333,3.335,3.335,0,0,1,3.338,3.333",
    transform: "translate(-250.893 -337.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67003",
    "data-name": "Path 67003",
    d: "M323.563,340.792a3.335,3.335,0,1,1-3.338-3.333,3.335,3.335,0,0,1,3.338,3.333",
    transform: "translate(-306.598 -337.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67004",
    "data-name": "Path 67004",
    d: "M389.564,340.741a3.335,3.335,0,1,1-3.338-3.333,3.336,3.336,0,0,1,3.338,3.333",
    transform: "translate(-362.305 -337.408)",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66316",
    "data-name": "Group 66316",
    transform: "translate(131.613 53.842)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66315",
    "data-name": "Group 66315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66314",
    "data-name": "Group 66314",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    y1: 0.083,
    x2: 107.128,
    transform: "translate(1.644 1.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26993",
    "data-name": "Rectangle 26993",
    width: 110.414,
    height: 3.285,
    transform: "translate(0.001 0.043)",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66319",
    "data-name": "Group 66319",
    transform: "translate(212.407 87.246)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66318",
    "data-name": "Group 66318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66317",
    "data-name": "Group 66317",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    y1: 0.076,
    x2: 97.744,
    transform: "translate(2.514 2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26995",
    "data-name": "Rectangle 26995",
    width: 102.768,
    height: 5.024,
    transform: "translate(0.002 0.039)",
    fill: "#c1a8db"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66322",
    "data-name": "Group 66322",
    transform: "translate(263.892 99.478)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66321",
    "data-name": "Group 66321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66320",
    "data-name": "Group 66320",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    y1: 0.036,
    x2: 46.262,
    transform: "translate(2.514 2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26997",
    "data-name": "Rectangle 26997",
    width: 51.285,
    height: 5.024,
    transform: "translate(0.002 0.019)",
    fill: "#c1a8db"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66325",
    "data-name": "Group 66325",
    transform: "translate(49.334 87.416)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66324",
    "data-name": "Group 66324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66323",
    "data-name": "Group 66323",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    y1: 0.032,
    x2: 41.491,
    transform: "translate(2.514 2.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26999",
    "data-name": "Rectangle 26999",
    width: 46.515,
    height: 5.024,
    transform: "translate(0.002 0.018)",
    fill: "#c1a8db"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67005",
    "data-name": "Path 67005",
    d: "M389.911,891.874l-66.936.052a5.645,5.645,0,0,1-5.649-5.641l-.085-109.3a5.645,5.645,0,0,1,5.641-5.649l66.936-.052a5.645,5.645,0,0,1,5.65,5.641l.085,109.3a5.645,5.645,0,0,1-5.641,5.65",
    transform: "translate(-267.761 -650.985)",
    fill: "#554bbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67006",
    "data-name": "Path 67006",
    d: "M989.2,891.41l-66.936.052a5.645,5.645,0,0,1-5.65-5.641l-.085-109.3a5.646,5.646,0,0,1,5.641-5.65l66.936-.052a5.645,5.645,0,0,1,5.649,5.641l.085,109.3a5.645,5.645,0,0,1-5.641,5.649",
    transform: "translate(-773.582 -650.594)",
    fill: "#e7e1ed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67007",
    "data-name": "Path 67007",
    d: "M1588.5,902.256l-66.936.056a5.926,5.926,0,0,1-5.649-6.17l-.085-119.554a5.929,5.929,0,0,1,5.641-6.179l66.936-.057a5.927,5.927,0,0,1,5.65,6.17l.085,119.554a5.929,5.929,0,0,1-5.641,6.18",
    transform: "translate(-1279.404 -650.202)",
    fill: "#554bbf"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27001",
    "data-name": "Rectangle 27001",
    width: 15.425,
    height: 3.919,
    transform: "matrix(0.985, -0.172, 0.172, 0.985, 2.287, 48.296)",
    fill: "#554bbf"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27002",
    "data-name": "Rectangle 27002",
    width: 3.919,
    height: 22.93,
    transform: "translate(0 26.487) rotate(-54.925)",
    fill: "#554bbf"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27003",
    "data-name": "Rectangle 27003",
    width: 3.919,
    height: 15.425,
    transform: "matrix(0.987, -0.162, 0.162, 0.987, 24.491, 17.316)",
    fill: "#554bbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66328",
    "data-name": "Group 66328",
    transform: "translate(99.848 44.993)",
    opacity: 0.11,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66327",
    "data-name": "Group 66327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66326",
    "data-name": "Group 66326",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67008",
    "data-name": "Path 67008",
    d: "M834.735,484.757l-194.556-.017.318-196.1,194.556-.16Z",
    transform: "translate(-640.18 -288.479)",
    fill: "#363636"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67104",
    "data-name": "Path 67104",
    d: "M0,0H247.377V196.075H0Z",
    transform: "translate(84.899 247.536) rotate(-90)",
    fill: "#fff"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27119",
    "data-name": "Rectangle 27119",
    width: 389.907,
    height: 278.951,
    transform: "translate(-1095.24 -12282.211)",
    fill: "none"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66360",
    "data-name": "Group 66360",
    transform: "translate(-33.082 -20.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66356",
    "data-name": "Group 66356",
    transform: "translate(1241.761 567.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66331",
    "data-name": "Group 66331",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67009",
    "data-name": "Path 67009",
    d: "M1011.861,200.439v0Z",
    transform: "translate(-1011.861 -200.439)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27007",
    "data-name": "Rectangle 27007",
    width: 0.631,
    height: 53.808,
    transform: "translate(0 0)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27008",
    "data-name": "Rectangle 27008",
    width: 0.631,
    height: 53.808,
    transform: "translate(0.631 0)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27009",
    "data-name": "Rectangle 27009",
    width: 0.631,
    height: 53.808,
    transform: "translate(1.263 0)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27010",
    "data-name": "Rectangle 27010",
    width: 0.631,
    height: 53.808,
    transform: "translate(1.894 0)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27011",
    "data-name": "Rectangle 27011",
    width: 0.631,
    height: 53.808,
    transform: "translate(2.525 0)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27012",
    "data-name": "Rectangle 27012",
    width: 0.631,
    height: 53.808,
    transform: "translate(3.156 0)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27013",
    "data-name": "Rectangle 27013",
    width: 0.631,
    height: 53.808,
    transform: "translate(3.788 0)",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27014",
    "data-name": "Rectangle 27014",
    width: 0.631,
    height: 53.808,
    transform: "translate(4.419 0)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27015",
    "data-name": "Rectangle 27015",
    width: 0.631,
    height: 53.808,
    transform: "translate(5.05 0)",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27016",
    "data-name": "Rectangle 27016",
    width: 0.631,
    height: 53.808,
    transform: "translate(5.681 0)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27017",
    "data-name": "Rectangle 27017",
    width: 0.631,
    height: 53.808,
    transform: "translate(6.313 0)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27018",
    "data-name": "Rectangle 27018",
    width: 0.631,
    height: 53.808,
    transform: "translate(6.944 0)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27019",
    "data-name": "Rectangle 27019",
    width: 0.631,
    height: 53.808,
    transform: "translate(7.575 0)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27020",
    "data-name": "Rectangle 27020",
    width: 0.631,
    height: 53.808,
    transform: "translate(8.206 0)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27021",
    "data-name": "Rectangle 27021",
    width: 0.631,
    height: 53.808,
    transform: "translate(8.838 0)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27022",
    "data-name": "Rectangle 27022",
    width: 0.631,
    height: 53.808,
    transform: "translate(9.469 0)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27023",
    "data-name": "Rectangle 27023",
    width: 0.631,
    height: 53.808,
    transform: "translate(10.1 0)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27024",
    "data-name": "Rectangle 27024",
    width: 0.631,
    height: 53.808,
    transform: "translate(10.732 0)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27025",
    "data-name": "Rectangle 27025",
    width: 0.631,
    height: 53.808,
    transform: "translate(11.363 0)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27026",
    "data-name": "Rectangle 27026",
    width: 0.631,
    height: 53.808,
    transform: "translate(11.994 0)",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27027",
    "data-name": "Rectangle 27027",
    width: 0.631,
    height: 53.808,
    transform: "translate(12.625 0)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27028",
    "data-name": "Rectangle 27028",
    width: 0.631,
    height: 53.808,
    transform: "translate(13.256 0)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27029",
    "data-name": "Rectangle 27029",
    width: 0.631,
    height: 53.808,
    transform: "translate(13.888 0)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27030",
    "data-name": "Rectangle 27030",
    width: 0.631,
    height: 53.808,
    transform: "translate(14.519 0)",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27031",
    "data-name": "Rectangle 27031",
    width: 0.631,
    height: 53.808,
    transform: "translate(15.15 0)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27032",
    "data-name": "Rectangle 27032",
    width: 0.631,
    height: 53.808,
    transform: "translate(15.782 0)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27033",
    "data-name": "Rectangle 27033",
    width: 0.631,
    height: 53.808,
    transform: "translate(16.413 0)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27034",
    "data-name": "Rectangle 27034",
    width: 0.631,
    height: 53.808,
    transform: "translate(17.044 0)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27035",
    "data-name": "Rectangle 27035",
    width: 0.631,
    height: 53.808,
    transform: "translate(17.675 0)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27036",
    "data-name": "Rectangle 27036",
    width: 0.631,
    height: 53.808,
    transform: "translate(18.307 0)",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27037",
    "data-name": "Rectangle 27037",
    width: 0.631,
    height: 53.808,
    transform: "translate(18.938 0)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27038",
    "data-name": "Rectangle 27038",
    width: 0.631,
    height: 53.808,
    transform: "translate(19.569 0)",
    fill: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27039",
    "data-name": "Rectangle 27039",
    width: 0.631,
    height: 53.808,
    transform: "translate(20.2 0)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27040",
    "data-name": "Rectangle 27040",
    width: 0.631,
    height: 53.808,
    transform: "translate(20.832 0)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27041",
    "data-name": "Rectangle 27041",
    width: 0.631,
    height: 53.808,
    transform: "translate(21.463 0)",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27042",
    "data-name": "Rectangle 27042",
    width: 0.631,
    height: 53.808,
    transform: "translate(22.094 0)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27043",
    "data-name": "Rectangle 27043",
    width: 0.631,
    height: 53.808,
    transform: "translate(22.726 0)",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27044",
    "data-name": "Rectangle 27044",
    width: 0.631,
    height: 53.808,
    transform: "translate(23.357 0)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27045",
    "data-name": "Rectangle 27045",
    width: 0.631,
    height: 53.808,
    transform: "translate(23.988 0)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27046",
    "data-name": "Rectangle 27046",
    width: 0.631,
    height: 53.808,
    transform: "translate(24.619 0)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27047",
    "data-name": "Rectangle 27047",
    width: 0.631,
    height: 53.808,
    transform: "translate(25.25 0)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27048",
    "data-name": "Rectangle 27048",
    width: 0.631,
    height: 53.808,
    transform: "translate(25.882 0)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27049",
    "data-name": "Rectangle 27049",
    width: 0.631,
    height: 53.808,
    transform: "translate(26.513 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27050",
    "data-name": "Rectangle 27050",
    width: 0.631,
    height: 53.808,
    transform: "translate(27.144 0)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27051",
    "data-name": "Rectangle 27051",
    width: 0.631,
    height: 53.808,
    transform: "translate(27.776 0)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27052",
    "data-name": "Rectangle 27052",
    width: 0.631,
    height: 53.808,
    transform: "translate(28.407 0)",
    fill: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27053",
    "data-name": "Rectangle 27053",
    width: 0.631,
    height: 53.808,
    transform: "translate(29.038 0)",
    fill: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27054",
    "data-name": "Rectangle 27054",
    width: 0.631,
    height: 53.808,
    transform: "translate(29.669 0)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27055",
    "data-name": "Rectangle 27055",
    width: 0.631,
    height: 53.808,
    transform: "translate(30.301 0)",
    fill: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27056",
    "data-name": "Rectangle 27056",
    width: 0.631,
    height: 53.808,
    transform: "translate(30.932 0)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27057",
    "data-name": "Rectangle 27057",
    width: 0.631,
    height: 53.808,
    transform: "translate(31.563 0)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27058",
    "data-name": "Rectangle 27058",
    width: 0.631,
    height: 53.808,
    transform: "translate(32.194 0)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27059",
    "data-name": "Rectangle 27059",
    width: 0.631,
    height: 53.808,
    transform: "translate(32.826 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27060",
    "data-name": "Rectangle 27060",
    width: 0.631,
    height: 53.808,
    transform: "translate(33.457 0)",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27061",
    "data-name": "Rectangle 27061",
    width: 0.631,
    height: 53.808,
    transform: "translate(34.088 0)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27062",
    "data-name": "Rectangle 27062",
    width: 0.631,
    height: 53.808,
    transform: "translate(34.719 0)",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27063",
    "data-name": "Rectangle 27063",
    width: 0.631,
    height: 53.808,
    transform: "translate(35.351 0)",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27064",
    "data-name": "Rectangle 27064",
    width: 0.631,
    height: 53.808,
    transform: "translate(35.982 0)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27065",
    "data-name": "Rectangle 27065",
    width: 0.631,
    height: 53.808,
    transform: "translate(36.613 0)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27066",
    "data-name": "Rectangle 27066",
    width: 0.631,
    height: 53.808,
    transform: "translate(37.244 0)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27067",
    "data-name": "Rectangle 27067",
    width: 0.631,
    height: 53.808,
    transform: "translate(37.876 0)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27068",
    "data-name": "Rectangle 27068",
    width: 0.631,
    height: 53.808,
    transform: "translate(38.507 0)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27069",
    "data-name": "Rectangle 27069",
    width: 0.631,
    height: 53.808,
    transform: "translate(39.138 0)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27070",
    "data-name": "Rectangle 27070",
    width: 0.631,
    height: 53.808,
    transform: "translate(39.769 0)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27071",
    "data-name": "Rectangle 27071",
    width: 0.631,
    height: 53.808,
    transform: "translate(40.401 0)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27072",
    "data-name": "Rectangle 27072",
    width: 0.631,
    height: 53.808,
    transform: "translate(41.032 0)",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27073",
    "data-name": "Rectangle 27073",
    width: 0.631,
    height: 53.808,
    transform: "translate(41.663 0)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27074",
    "data-name": "Rectangle 27074",
    width: 0.631,
    height: 53.808,
    transform: "translate(42.295 0)",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27075",
    "data-name": "Rectangle 27075",
    width: 0.631,
    height: 53.808,
    transform: "translate(42.926 0)",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27076",
    "data-name": "Rectangle 27076",
    width: 0.631,
    height: 53.808,
    transform: "translate(43.557 0)",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27077",
    "data-name": "Rectangle 27077",
    width: 0.631,
    height: 53.808,
    transform: "translate(44.188 0)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27078",
    "data-name": "Rectangle 27078",
    width: 0.631,
    height: 53.808,
    transform: "translate(44.819 0)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27079",
    "data-name": "Rectangle 27079",
    width: 0.631,
    height: 53.808,
    transform: "translate(45.451 0)",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27080",
    "data-name": "Rectangle 27080",
    width: 0.631,
    height: 53.808,
    transform: "translate(46.082 0)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27081",
    "data-name": "Rectangle 27081",
    width: 0.631,
    height: 53.808,
    transform: "translate(46.713 0)",
    fill: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27082",
    "data-name": "Rectangle 27082",
    width: 0.631,
    height: 53.808,
    transform: "translate(47.345 0)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27083",
    "data-name": "Rectangle 27083",
    width: 0.631,
    height: 53.808,
    transform: "translate(47.976 0)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27084",
    "data-name": "Rectangle 27084",
    width: 0.631,
    height: 53.808,
    transform: "translate(48.607 0)",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27085",
    "data-name": "Rectangle 27085",
    width: 0.631,
    height: 53.808,
    transform: "translate(49.238 0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27086",
    "data-name": "Rectangle 27086",
    width: 0.631,
    height: 53.808,
    transform: "translate(49.87 0)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27087",
    "data-name": "Rectangle 27087",
    width: 0.631,
    height: 53.808,
    transform: "translate(50.501 0)",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27088",
    "data-name": "Rectangle 27088",
    width: 0.631,
    height: 53.808,
    transform: "translate(51.132 0)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27089",
    "data-name": "Rectangle 27089",
    width: 0.631,
    height: 53.808,
    transform: "translate(51.763 0)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27090",
    "data-name": "Rectangle 27090",
    width: 0.631,
    height: 53.808,
    transform: "translate(52.395 0)",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27091",
    "data-name": "Rectangle 27091",
    width: 0.631,
    height: 53.808,
    transform: "translate(53.026 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27092",
    "data-name": "Rectangle 27092",
    width: 0.631,
    height: 53.808,
    transform: "translate(53.657 0)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27093",
    "data-name": "Rectangle 27093",
    width: 0.631,
    height: 53.808,
    transform: "translate(54.289 0)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27094",
    "data-name": "Rectangle 27094",
    width: 0.631,
    height: 53.808,
    transform: "translate(54.92 0)",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27095",
    "data-name": "Rectangle 27095",
    width: 0.631,
    height: 53.808,
    transform: "translate(55.551 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27096",
    "data-name": "Rectangle 27096",
    width: 0.631,
    height: 53.808,
    transform: "translate(56.182 0)",
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27097",
    "data-name": "Rectangle 27097",
    width: 0.631,
    height: 53.808,
    transform: "translate(56.813 0)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27098",
    "data-name": "Rectangle 27098",
    width: 0.631,
    height: 53.808,
    transform: "translate(57.445 0)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67010",
    "data-name": "Path 67010",
    d: "M1330.194,254.247v0Z",
    transform: "translate(-1272.118 -200.439)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66357",
    "data-name": "Group 66357",
    transform: "translate(1230.786 610.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66333",
    "data-name": "Group 66333",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67012",
    "data-name": "Path 67012",
    d: "M952.81,435.5,951.7,436.6V435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fde07c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67013",
    "data-name": "Path 67013",
    d: "M954.229,435.5l-2.526,2.526V436.6l1.107-1.107Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fddf7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67014",
    "data-name": "Path 67014",
    d: "M955.649,435.5l-3.945,3.945v-1.419l2.526-2.526Z",
    transform: "translate(-951.704 -435.496)",
    fill: "#fdde7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67015",
    "data-name": "Path 67015",
    d: "M957.068,435.5l-5.364,5.364v-1.419l3.945-3.945Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fdde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67016",
    "data-name": "Path 67016",
    d: "M958.487,435.5,951.7,442.28v-1.419l5.364-5.364Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fddd79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67017",
    "data-name": "Path 67017",
    d: "M959.906,435.5l-8.2,8.2V442.28l6.783-6.783Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fddc78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67018",
    "data-name": "Path 67018",
    d: "M961.325,435.5l-9.622,9.622V443.7l8.2-8.2Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fcdc77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67019",
    "data-name": "Path 67019",
    d: "M962.744,435.5,951.7,446.537v-1.419l9.621-9.622Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fcdb77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67020",
    "data-name": "Path 67020",
    d: "M964.163,435.5l-12.46,12.46v-1.419L962.744,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fcda76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67021",
    "data-name": "Path 67021",
    d: "M965.582,435.5,951.7,449.375v-1.419l12.46-12.46Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fcd975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67022",
    "data-name": "Path 67022",
    d: "M967,435.5l-15.3,15.3v-1.419L965.582,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fcd974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67023",
    "data-name": "Path 67023",
    d: "M968.421,435.5,951.7,452.214v-1.419L967,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fcd873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67024",
    "data-name": "Path 67024",
    d: "M969.84,435.5,951.7,453.633v-1.419L968.421,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fbd772"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67025",
    "data-name": "Path 67025",
    d: "M971.259,435.5,951.7,455.052v-1.419L969.84,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fbd771"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67026",
    "data-name": "Path 67026",
    d: "M972.678,435.5,951.7,456.471v-1.419L971.259,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fbd670"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67027",
    "data-name": "Path 67027",
    d: "M974.1,435.5,951.7,457.89v-1.419L972.678,435.5Z",
    transform: "translate(-951.704 -435.496)",
    fill: "#fbd56f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67028",
    "data-name": "Path 67028",
    d: "M975.517,435.5,951.7,459.309V457.89L974.1,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fbd46f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67029",
    "data-name": "Path 67029",
    d: "M976.936,435.5,951.7,460.729v-1.419L975.516,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fbd46e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67030",
    "data-name": "Path 67030",
    d: "M978.354,435.5,951.7,462.148v-1.419L976.935,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fbd36d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67031",
    "data-name": "Path 67031",
    d: "M979.773,435.5,951.7,463.567v-1.419L978.354,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fad26c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67032",
    "data-name": "Path 67032",
    d: "M981.193,435.5l-29.49,29.49v-1.419l28.07-28.071Z",
    transform: "translate(-951.704 -435.496)",
    fill: "#fad16b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67033",
    "data-name": "Path 67033",
    d: "M982.612,435.5,951.7,466.405v-1.419l29.49-29.49Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fad16a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67034",
    "data-name": "Path 67034",
    d: "M984.031,435.5,951.7,467.824v-1.419L982.612,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#fad069"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67035",
    "data-name": "Path 67035",
    d: "M985.45,435.5,951.7,469.243v-1.419L984.031,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#facf68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67036",
    "data-name": "Path 67036",
    d: "M986.87,435.5,951.7,470.662v-1.419L985.451,435.5Z",
    transform: "translate(-951.704 -435.496)",
    fill: "#face67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67037",
    "data-name": "Path 67037",
    d: "M988.289,435.5,951.7,472.082v-1.419L986.87,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f9cd66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67038",
    "data-name": "Path 67038",
    d: "M989.708,435.5l-38,38v-1.419L988.289,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f9cd65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67039",
    "data-name": "Path 67039",
    d: "M991.127,435.5,951.7,474.92V473.5l38-38Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f9cc64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67040",
    "data-name": "Path 67040",
    d: "M992.546,435.5,951.7,476.339V474.92L991.127,435.5Z",
    transform: "translate(-951.704 -435.496)",
    fill: "#f9cb63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67041",
    "data-name": "Path 67041",
    d: "M993.966,435.5,951.7,477.758v-1.419L992.546,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f9ca62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67042",
    "data-name": "Path 67042",
    d: "M995.385,435.5,951.7,479.177v-1.419L993.965,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f8c961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67043",
    "data-name": "Path 67043",
    d: "M996.8,435.5l-45.1,45.1v-1.419L995.384,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f8c860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67044",
    "data-name": "Path 67044",
    d: "M998.222,435.5,951.7,482.016V480.6l45.1-45.1Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f8c85f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67045",
    "data-name": "Path 67045",
    d: "M999.642,435.5,951.7,483.435v-1.419L998.223,435.5Z",
    transform: "translate(-951.704 -435.496)",
    fill: "#f8c75e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67046",
    "data-name": "Path 67046",
    d: "M1001.061,435.5,951.7,484.854v-1.419L999.642,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f8c65d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67047",
    "data-name": "Path 67047",
    d: "M1002.48,435.5,951.7,486.273v-1.419l49.358-49.358Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f8c55b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67048",
    "data-name": "Path 67048",
    d: "M1003.9,435.5l-52.2,52.2v-1.419L1002.48,435.5Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f7c45a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67049",
    "data-name": "Path 67049",
    d: "M1005.318,435.5,951.7,489.111v-1.419l52.2-52.2Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f7c359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67050",
    "data-name": "Path 67050",
    d: "M1006.738,435.5,951.7,490.53v-1.419l53.615-53.615Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f7c358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67051",
    "data-name": "Path 67051",
    d: "M1008.157,435.5,951.7,491.95V490.53l55.034-55.034Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f7c257"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67052",
    "data-name": "Path 67052",
    d: "M1009.576,435.5,951.7,493.369V491.95l56.453-56.453Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f7c156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67053",
    "data-name": "Path 67053",
    d: "M1010.994,435.5l-59.235,59.235-.057-.057v-1.306l57.872-57.872Z",
    transform: "translate(-951.703 -435.496)",
    fill: "#f7c055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67054",
    "data-name": "Path 67054",
    d: "M1012.668,435.5l-59.945,59.945-.709-.71,59.235-59.235Z",
    transform: "translate(-951.957 -435.496)",
    fill: "#f6bf54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67055",
    "data-name": "Path 67055",
    d: "M1017.267,435.5l-60.654,60.654-.709-.71,59.944-59.945Z",
    transform: "translate(-955.137 -435.496)",
    fill: "#f6be53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67056",
    "data-name": "Path 67056",
    d: "M1021.866,435.5,960.6,496.764h-.192l-.614-.614,60.654-60.654Z",
    transform: "translate(-958.316 -435.496)",
    fill: "#f6bd52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67057",
    "data-name": "Path 67057",
    d: "M1026.895,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-961.927 -435.496)",
    fill: "#f6bc51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67058",
    "data-name": "Path 67058",
    d: "M1034.674,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-968.286 -435.496)",
    fill: "#f6bb4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67059",
    "data-name": "Path 67059",
    d: "M1042.452,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-974.646 -435.496)",
    fill: "#f5bb4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67060",
    "data-name": "Path 67060",
    d: "M1050.231,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-981.005 -435.496)",
    fill: "#f5ba4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67061",
    "data-name": "Path 67061",
    d: "M1058.01,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-987.365 -435.496)",
    fill: "#f5b94c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67062",
    "data-name": "Path 67062",
    d: "M1065.789,435.5l-61.268,61.268H1003.1L1064.37,435.5Z",
    transform: "translate(-993.725 -435.496)",
    fill: "#f5b84b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67063",
    "data-name": "Path 67063",
    d: "M1073.568,435.5,1012.3,496.764h-1.419l61.268-61.268Z",
    transform: "translate(-1000.084 -435.496)",
    fill: "#f5b74a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67064",
    "data-name": "Path 67064",
    d: "M1081.346,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-1006.444 -435.496)",
    fill: "#f4b649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67065",
    "data-name": "Path 67065",
    d: "M1089.125,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-1012.804 -435.496)",
    fill: "#f4b548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67066",
    "data-name": "Path 67066",
    d: "M1096.9,435.5l-61.268,61.268h-1.419l61.268-61.268Z",
    transform: "translate(-1019.163 -435.496)",
    fill: "#f4b446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67067",
    "data-name": "Path 67067",
    d: "M1103.459,435.5l.612.611-60.656,60.657H1042l61.268-61.268Z",
    transform: "translate(-1025.523 -435.496)",
    fill: "#f4b345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67068",
    "data-name": "Path 67068",
    d: "M1110.431,438.848l.709.71L1051.193,499.5h-1.419Z",
    transform: "translate(-1031.882 -438.236)",
    fill: "#f4b244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67069",
    "data-name": "Path 67069",
    d: "M1117.5,442.737l.709.709-59.237,59.237h-1.419Z",
    transform: "translate(-1038.242 -441.416)",
    fill: "#f3b143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67070",
    "data-name": "Path 67070",
    d: "M1124.569,446.627l.059.059v1.3l-57.877,57.877h-1.419Z",
    transform: "translate(-1044.602 -444.596)",
    fill: "#f3b042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67071",
    "data-name": "Path 67071",
    d: "M1130.987,455.5l-56.458,56.458h-1.419l57.877-57.877Z",
    transform: "translate(-1050.961 -450.692)",
    fill: "#f3b041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67072",
    "data-name": "Path 67072",
    d: "M1137.347,463.281l-55.039,55.039h-1.419l56.458-56.458Z",
    transform: "translate(-1057.321 -457.052)",
    fill: "#f3af3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67073",
    "data-name": "Path 67073",
    d: "M1143.707,471.06l-53.62,53.619h-1.419l55.039-55.039Z",
    transform: "translate(-1063.681 -463.411)",
    fill: "#f3ae3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67074",
    "data-name": "Path 67074",
    d: "M1150.066,478.838l-52.2,52.2h-1.419l53.619-53.62Z",
    transform: "translate(-1070.04 -469.771)",
    fill: "#f2ad3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67075",
    "data-name": "Path 67075",
    d: "M1156.426,486.617,1105.645,537.4h-1.419l52.2-52.2Z",
    transform: "translate(-1076.4 -476.131)",
    fill: "#f2ac3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67076",
    "data-name": "Path 67076",
    d: "M1162.786,494.4l-49.362,49.362H1112l50.781-50.781Z",
    transform: "translate(-1082.759 -482.49)",
    fill: "#f2ab3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67077",
    "data-name": "Path 67077",
    d: "M1169.145,502.175,1121.2,550.117h-1.419l49.362-49.362Z",
    transform: "translate(-1089.119 -488.85)",
    fill: "#f2aa39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67078",
    "data-name": "Path 67078",
    d: "M1175.5,509.953l-46.524,46.524h-1.419l47.943-47.943Z",
    transform: "translate(-1095.478 -495.209)",
    fill: "#f2a938"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67079",
    "data-name": "Path 67079",
    d: "M1181.864,517.732l-45.1,45.1h-1.419l46.524-46.524Z",
    transform: "translate(-1101.838 -501.569)",
    fill: "#f1a837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67080",
    "data-name": "Path 67080",
    d: "M1188.224,525.511,1144.539,569.2h-1.419l45.1-45.1Z",
    transform: "translate(-1108.198 -507.929)",
    fill: "#f1a736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67081",
    "data-name": "Path 67081",
    d: "M1194.584,533.29l-42.266,42.266H1150.9l43.685-43.685Z",
    transform: "translate(-1114.558 -514.288)",
    fill: "#f1a635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67082",
    "data-name": "Path 67082",
    d: "M1200.943,541.068,1160.1,581.916h-1.419l42.266-42.266Z",
    transform: "translate(-1120.917 -520.648)",
    fill: "#f1a533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67083",
    "data-name": "Path 67083",
    d: "M1207.3,548.847l-39.428,39.428h-1.419l40.847-40.847Z",
    transform: "translate(-1127.276 -527.008)",
    fill: "#f1a432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67084",
    "data-name": "Path 67084",
    d: "M1213.663,556.626l-38.009,38.009h-1.419l39.428-39.428Z",
    transform: "translate(-1133.636 -533.367)",
    fill: "#f0a331"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67085",
    "data-name": "Path 67085",
    d: "M1220.022,564.4l-36.59,36.59h-1.419l38.009-38.009Z",
    transform: "translate(-1139.996 -539.727)",
    fill: "#f0a230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67086",
    "data-name": "Path 67086",
    d: "M1226.382,572.183l-35.171,35.171h-1.419l36.59-36.59Z",
    transform: "translate(-1146.356 -546.086)",
    fill: "#f0a12f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67087",
    "data-name": "Path 67087",
    d: "M1232.741,579.962l-33.751,33.752h-1.419l35.171-35.171Z",
    transform: "translate(-1152.715 -552.446)",
    fill: "#f0a02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67088",
    "data-name": "Path 67088",
    d: "M1239.1,587.741l-32.332,32.332h-1.419l33.751-33.752Z",
    transform: "translate(-1159.075 -558.806)",
    fill: "#f09f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67089",
    "data-name": "Path 67089",
    d: "M1245.461,595.52l-30.913,30.913h-1.419l32.332-32.332Z",
    transform: "translate(-1165.435 -565.165)",
    fill: "#ef9e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67090",
    "data-name": "Path 67090",
    d: "M1251.821,603.3l-29.494,29.494h-1.419l30.913-30.913Z",
    transform: "translate(-1171.794 -571.525)",
    fill: "#ef9d2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67091",
    "data-name": "Path 67091",
    d: "M1258.179,611.077,1230.1,639.152h-1.419l29.494-29.494Z",
    transform: "translate(-1178.153 -577.885)",
    fill: "#ef9c28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67092",
    "data-name": "Path 67092",
    d: "M1264.539,618.856l-26.656,26.656h-1.419l28.075-28.075Z",
    transform: "translate(-1184.513 -584.244)",
    fill: "#ef9b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67093",
    "data-name": "Path 67093",
    d: "M1270.9,626.635l-25.236,25.237h-1.419l26.656-26.656Z",
    transform: "translate(-1190.873 -590.604)",
    fill: "#ef9a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67094",
    "data-name": "Path 67094",
    d: "M1277.259,634.414l-23.818,23.817h-1.419l25.237-25.237Z",
    transform: "translate(-1197.233 -596.963)",
    fill: "#ee9925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67095",
    "data-name": "Path 67095",
    d: "M1283.619,642.193l-22.4,22.4H1259.8l23.817-23.818Z",
    transform: "translate(-1203.593 -603.323)",
    fill: "#ee9823"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67096",
    "data-name": "Path 67096",
    d: "M1289.978,649.971,1269,670.951h-1.419l22.4-22.4Z",
    transform: "translate(-1209.952 -609.683)",
    fill: "#ee9722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67097",
    "data-name": "Path 67097",
    d: "M1296.338,657.75l-19.56,19.56h-1.419l20.979-20.979Z",
    transform: "translate(-1216.312 -616.042)",
    fill: "#ee9621"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67098",
    "data-name": "Path 67098",
    d: "M1302.7,665.529l-18.141,18.141h-1.419l19.56-19.56Z",
    transform: "translate(-1222.671 -622.402)",
    fill: "#ed9520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67099",
    "data-name": "Path 67099",
    d: "M1309.057,673.307l-16.722,16.722h-1.419l18.141-18.141Z",
    transform: "translate(-1229.031 -628.762)",
    fill: "#ed941e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67100",
    "data-name": "Path 67100",
    d: "M1315.416,681.086l-15.3,15.3h-1.419l16.722-16.722Z",
    transform: "translate(-1235.39 -635.121)",
    fill: "#ed931d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67101",
    "data-name": "Path 67101",
    d: "M1306.474,702.749l15.3-15.3v15.3Z",
    transform: "translate(-1241.75 -641.481)",
    fill: "#ed931d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66358",
    "data-name": "Group 66358",
    transform: "translate(1267.999 637.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66338",
    "data-name": "Group 66338",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66337",
    "data-name": "Group 66337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66336",
    "data-name": "Group 66336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66335",
    "data-name": "Group 66335",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_27100",
    "data-name": "Rectangle 27100",
    width: 5.692,
    height: 17.251,
    transform: "translate(-0.058 -0.048)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAADFCAIAAACEtAjcAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAQaADAAQAAAABAAAAxQAAAACbOZQrAAADPklEQVR4Ae1YW27DMAxbh56/typ6rE6bhyLzapdKLNklmI8BSWjrQbqhdrper7fb7eOdr7MVcLlc3rmEj8+3zr4krxrWIFE8rMHD+fRzrZHMziykpZ2NG7xMPAxu6M7tzrbOTvXO1Wssk5bEw6gOSEujOnlgH/tBktc40L+BS3UeBjbzwFYMPMhrHBDAwKUMWlINAwVxYCsGHuQ1Dghg4FIGLamGgYI4sNW31wCv8u+P+/2+FN6Scfsl7z9yovFWg84DqKpgmHgIbjC4vbwG2KhgmM5DcIPB7Rl4QL3G9nOL2I0HHgFbv3fjba3ba2zjIVw/kkPA3s3LngxaUg2gPoJhDDzIawSLBNyeQUuqASQ7GMbAwx6vEdxW9/YMPKgGN+0hCxh4gGag7QyAzDSZeGPW7Ze2+SHKiMZbDgxaUg2ImOIxDDzIa8TrBInAoCXVgDAdj3ntNaoP7UuvkYy3FslrxOsEiaAzjXQpHsPAg7xGvE6QCAxaUg0I0/EYBh7cXiO+re4IDDyoBjftIQsYeHgxA1UDjbWxPwPl4y0lt1/6n2VfH9F4i86gJdXQl1HWWwYe5DWy1NKPw6Al1dDnOOttz2s8/cR2vMYUvDVKXiNLLf04OtP9/mS9ZeBBXiNLLf04DFpSDX2Os94y8OD2GlnNdcRh4EE1OAgPhDLw0JyBng401szWDDQLbym5/VIr15ZWovEWl0FLqqEloNznDDzIa+RqphWNQUuqocVu7vPnXqPzcX3qNSbirV3yGrmaaUXTmW51Jvc5Aw/yGrmaaUVj0JJqaLGb+5yBB7fXyG0xFI2BB9UAUR0OYuChnoE600zpZzUDTcdbVm6/9DLpSjrReAvHoCXVUOlm0i0DD/Iak8RThWXQkmqoSJ10+8drIN/UrddYAW99k9eYJJ4qrM501ZBJtww8yGtMEk8VlkFLqqEiddItAw9urzGp172wDDyohh7Dee8YePidgZBppjS2zEBevK0FlzxmLBBvO7v9Er51qTkab1EYtKQailxm/2XgQV5jtopKfAYtqYY1tJTkNfCvtdfLWBvlNdbQks60eBjVAYrfJWsG/sPnBSfgLYTOtDVhgUs8LECCpfAFaBCAxd8B9gQAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66359",
    "data-name": "Group 66359",
    transform: "translate(1057.16 531.339)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67009-2",
    "data-name": "Path 67009",
    d: "M1137.062,552.353a6.2,6.2,0,1,1,6.2,6.2,6.2,6.2,0,0,1-6.2-6.2",
    transform: "translate(-929.619 -446.517)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67103",
    "data-name": "Path 67103",
    d: "M0,0H148.358V49.662H0Z",
    transform: "translate(140.785 166.445)",
    fill: "#f1f0fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27122",
    "data-name": "Rectangle 27122",
    width: 148.109,
    height: 5.685,
    transform: "translate(140.91 216.352)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66365",
    "data-name": "Group 66365"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27123",
    "data-name": "Rectangle 27123",
    width: 3.547,
    height: 20.048,
    transform: "translate(166.647 182.994)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27124",
    "data-name": "Rectangle 27124",
    width: 20.048,
    height: 3.547,
    transform: "matrix(0.855, -0.519, 0.519, 0.855, 158.932, 196.709)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27125",
    "data-name": "Rectangle 27125",
    width: 3.547,
    height: 20.048,
    transform: "matrix(0.519, -0.855, 0.855, 0.519, 158.933, 189.328)",
    fill: "#67629d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27126",
    "data-name": "Rectangle 27126",
    width: 3.547,
    height: 20.048,
    transform: "translate(197.28 182.994)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27127",
    "data-name": "Rectangle 27127",
    width: 20.048,
    height: 3.547,
    transform: "translate(189.566 196.709) rotate(-31.288)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27128",
    "data-name": "Rectangle 27128",
    width: 3.547,
    height: 20.048,
    transform: "translate(189.566 189.328) rotate(-58.712)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27129",
    "data-name": "Rectangle 27129",
    width: 3.547,
    height: 20.048,
    transform: "translate(227.913 182.994)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27130",
    "data-name": "Rectangle 27130",
    width: 20.048,
    height: 3.547,
    transform: "translate(220.199 196.709) rotate(-31.288)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27131",
    "data-name": "Rectangle 27131",
    width: 3.547,
    height: 20.048,
    transform: "translate(220.199 189.328) rotate(-58.713)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27132",
    "data-name": "Rectangle 27132",
    width: 3.547,
    height: 20.048,
    transform: "translate(258.546 182.994)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27133",
    "data-name": "Rectangle 27133",
    width: 20.048,
    height: 3.547,
    transform: "translate(250.833 196.709) rotate(-31.288)",
    fill: "#67629d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27134",
    "data-name": "Rectangle 27134",
    width: 3.547,
    height: 20.048,
    transform: "translate(250.833 189.328) rotate(-58.712)",
    fill: "#67629d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeavrOnboardingPassword);
export default __webpack_public_path__ + "static/media/weavr_onboarding_password.0a44210fc78003eaa4b0f56a8523720a.svg";
export { ForwardRef as ReactComponent };